import { render } from "./RecommendMachine.vue?vue&type=template&id=26fc5873&scoped=true"
import script from "./RecommendMachine.vue?vue&type=script&lang=js"
export * from "./RecommendMachine.vue?vue&type=script&lang=js"

import "./RecommendMachine.vue?vue&type=style&index=0&id=26fc5873&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fc5873"]])

export default __exports__